export default __webpack_public_path__ + "static/media/location.e9f08823.svg";